import { Menu, X } from "lucide-react";
import mobileStyles from "../../styles/docs/docsMobile.module.scss";

const DocsMobileMenuButton = ({ open, onToggle }) => (
  <div className={mobileStyles.fabContainer}>
    <button
      type="button"
      onClick={onToggle}
      className={mobileStyles.fab}
      aria-label={open ? "Close documentation menu" : "Open documentation menu"}
    >
      {open ? <X size={20} /> : <Menu size={20} />}
    </button>
  </div>
);

export default DocsMobileMenuButton;
